import { aqua } from 'assets/stylesheets/base/_colors';
import SiteDrillDownGenerator from './siteDrillDownGenerator.abstract';

class DropOutGenerator extends SiteDrillDownGenerator {
  generateSeries(dataArray, dataKey) {
    const dataSeries = super.generateSeries(dataArray, dataKey);
    const dropoutChartData = [
      {
        name: 'All sites',
        colorByPoint: false,
        color: aqua,
        data: dataSeries,
      },
    ];
    return dropoutChartData;
  }
}

export default DropOutGenerator;
